import { cn } from "@/lib/cn";

export function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="relative h-8 w-8">
        <div className="absolute inset-0 rounded-md border border-brand-blue/60 bg-brand-blue/10 animate-pulseGlow" />
        <div className="absolute inset-[5px] rounded-sm border border-brand-red/70 bg-brand-red/20" />
      </div>
      <div className="font-display font-extrabold uppercase tracking-[0.18em] text-silver-50 text-lg leading-none">
        INFINI<span className="text-brand-red">·</span>X
      </div>
    </div>
  );
}
